const initialState = {
    type: '',
    active: true,
    params: ''
};

const setNotificationSettingsReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'SET_NOTIFICATION_SETTINGS':
            return {
                ...state,
                type: action.payload.type,
                active: JSON.parse(action.payload.active),
                params: action.payload.params
            };
        case 'SET_NOTIFICATION_ACTIVE':
            return {
                ...state,
                active: JSON.parse(action.payload.active)
            };
        default:
            return state;
    }
};

export default setNotificationSettingsReducer;